"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/blogsSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogsSection466sItem = {
    key: Key | null | undefined;
    /** Detected variants: "26" | "30" | "28" */
    div0Text: ReactNode;
    /** Detected variants: "Apr" | "Mar" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/skin-blog-01.jpg" | "/Templates/Doccure/img/blog/skin-blog-02.jpg" */
    src: string;
    /** Detected variants: "Skincare Tips" | "Product Reviews" | "DIY Remedies" */
    link0Text: ReactNode;
    /** Detected variants: "Comments (5)" | "Comments (2)" | "Comments (7)" */
    p0Text: ReactNode;
    /** Detected variants: "The Ultimate Guide to Glowing Skin: Morning & Night Routines" | "Top 5 Sunscreens for Sensitive Skin in 2026" | "Natural Ingredients That Can Help Combat Acne" */
    link0Link0Text: ReactNode;
    /** Detected variants: "col-lg-4 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "blog-item-fourteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "blog-img" */
    div0ClassName2?: string;
    /** Detected variants: "blog-date" */
    div0ClassName3?: string;
    /** Detected variants: "blogs" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "blog-tags" */
    div0ClassName4?: string;
    /** Detected variants: "badge bg-light text-dark" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.blogGrid" */
    href?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
    /** Detected variants: "isax isax-messages-15 me-2" */
    i0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href?: string;
};
export type HomeFourteenBlogsSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogsSection466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogsSection466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogsSection466sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogsSection466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Check Out" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Latest" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "News & Articles" */
    sectionDiv0Div0H20Span1SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    blogsSection466s: BlogsSection466sItem[];
    blogsSection466sItemWrapper?: (item: BlogsSection466sItem, content: ReactNode) => ReactNode;
    blogsSection466sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogsSection466sLinkVisible?: boolean;
    blogsSection466sLinkRenderer?: (item: BlogsSection466sItem, defaultNode: ReactNode) => ReactNode;
    blogsSection466sImageVisible?: boolean;
    blogsSection466sImageRenderer?: (item: BlogsSection466sItem, defaultNode: ReactNode) => ReactNode;
    blogsSection466sH3Visible?: boolean;
    blogsSection466sH3Renderer?: (item: BlogsSection466sItem, defaultNode: ReactNode) => ReactNode;
    blogsSection466sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogsSection466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogsSection466sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogsSection466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogsSection466sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogsSection466sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourteenBlogsSectionGenerated: FC<HomeFourteenBlogsSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Check Out",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Latest",
    sectionDiv0Div0H20Span1SpanText = "News & Articles",
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogsSection466s,
    blogsSection466sItemWrapper,
    blogsSection466sRenderer,
    blogsSection466sLinkVisible,
    blogsSection466sLinkRenderer,
    blogsSection466sImageVisible,
    blogsSection466sImageRenderer,
    blogsSection466sH3Visible,
    blogsSection466sH3Renderer,
    blogsSection466sLinkProps,
    blogsSection466sImageProps,
    blogsSection466sH3Props,
}) => {
    return (
        <section className="blog-section-fourteen section">
            <div className="container">
                <div className="section-header section-header-fourteen text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span className="section-line">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                            <span className="subtitle">{sectionDiv0Div0H20Span1SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4 justify-content-center"}>
                    {renderCollectionNode(
                        blogsSection466s,
                        (item: BlogsSection466sItem) => (
                            <div className={item.className ?? "col-lg-4 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-fourteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "blog-img"}>
                                        {renderItemNode(blogsSection466sImageVisible, blogsSection466sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "blogs"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof blogsSection466sImageProps === "function" ? blogsSection466sImageProps(item) : (blogsSection466sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <div className={item.div0ClassName3 ?? "blog-date"}>
                                            {item.div0Text}
                                            <span>{item.span0Text}</span>
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        <div className={item.div0ClassName4 ?? "blog-tags"}>
                                            {renderItemNode(blogsSection466sLinkVisible, blogsSection466sLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "all_routes.blogGrid"} className={item.link0ClassName ?? "badge bg-light text-dark"} {...(typeof blogsSection466sLinkProps === "function" ? blogsSection466sLinkProps(item) : (blogsSection466sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0Link0LinkProps === "function" ? divDiv0Div1Div0Link0LinkProps(item) : (divDiv0Div1Div0Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                            <p className={item.p0ClassName ?? "mb-0"}>
                                                <i className={item.i0ClassName ?? "isax isax-messages-15 me-2"} />
                                                {item.p0Text}
                                            </p>
                                        </div>
                                        {renderItemNode(blogsSection466sH3Visible, blogsSection466sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogsSection466sH3Props === "function" ? blogsSection466sH3Props(item) : (blogsSection466sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(blogsSection466sLinkVisible, blogsSection466sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.blogDetails"} {...(typeof blogsSection466sLinkProps === "function" ? blogsSection466sLinkProps(item) : (blogsSection466sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        blogsSection466sItemWrapper,
                        blogsSection466sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFourteenBlogsSectionGenerated;
